import { combineReducers } from 'redux';
import questions from './questions';
import submission from './submission';
import next_question from './next_question';

const quizApp = combineReducers({
  questions,
  submission,
  next_question
});

export default quizApp;


// WEBPACK FOOTER //
// ./src/reducers/index.js